import { Injectable } from '@angular/core';
import { AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * Custom ErrorStateMatcher that shows errors immediately as the user types,
 * rather than waiting for blur (Angular Material default behavior).
 *
 * Usage:
 *   1. Import: import { ImmediateErrorStateMatcher } from '@cdw-ae/common-frontend-materials';
 *   2. Create instance: errorStateMatcher = new ImmediateErrorStateMatcher();
 *   3. Bind in template: [errorStateMatcher]="errorStateMatcher"
 */
@Injectable({ providedIn: 'root' })
export class ImmediateErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, _form: FormGroupDirective | NgForm | null): boolean {
    return !!(control?.invalid && (control.dirty || control.touched));
  }
}
